import { render } from "./App.vue?vue&type=template&id=3b7f5cf8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3b7f5cf8&lang=css"

import exportComponent from "D:\\Users\\Igory\\Desktop\\my_first_vue.js_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__